import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Contact({ settings }) {
  const [content, setContent] = useState(null);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await axios.get('/api/content');
      setContent(response.data);
    } catch (error) {
      console.error('Error fetching content:', error);
    }
  };

  if (!content || !settings) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="container">
      <section className="section">
        <h2>{content.contact_info?.title || 'Get In Touch'}</h2>
        <p>{content.contact_info?.text || 'Have questions? We\'re here to help!'}</p>
      </section>

      <div className="contact-info">
        <h3>Contact Information</h3>
        <p><strong>Company:</strong> {settings.company_name}</p>
        <p><strong>Phone:</strong> <a href={`tel:${settings.phone}`}>{settings.phone}</a></p>
        <p><strong>Email:</strong> <a href={`mailto:${settings.email}`}>{settings.email}</a></p>
        <p><strong>Address:</strong> {settings.address}</p>
      </div>
    </div>
  );
}

export default Contact;
